// frontend/src/components/PrepPanel.js

import React from 'react';
import PrepRow from './PrepRow';
import RiskMeter from './RiskMeter';
import './PrepPanel.css';

const PrepPanel = ({ prepRows }) => {
  console.log('PrepPanel - received prepRows:', prepRows);

  if (!prepRows || !prepRows.p) {
    return (
      <div className="prep-panel">
        <h3 className="prep-panel-title">PREP Assessment</h3>
        <div className="prep-panel-empty">
          No PREP data available for this job yet.
        </div>
      </div>
    );
  }

  // 1. Calculate ONE Overall Score by pooling all questions
  let totalYes = 0;
  let totalQs = 0;
  
  ['p', 'r', 'e', 'p2'].forEach((key) => {
    if (prepRows[key] && prepRows[key].questions) {
      totalYes += prepRows[key].questions.filter((q) => q.value === 'yes').length;
      totalQs += prepRows[key].questions.length;
    }
  });

  const overallScore = totalQs > 0 ? Math.round((totalYes / totalQs) * 100) : 0;

  return (
    <div className="prep-panel">
      <h3 className="prep-panel-title">PREP Assessment</h3>

      {/* 🔹 Gauge strip on top */}
      <div className="prep-gauge-strip">
        
        {/* Gauge 1: Overall PREP Score */}
        <div className="prep-gauge-item">
          <div className="prep-gauge-label">Overall PREP Score</div>
          <RiskMeter score={overallScore} />
          <div className="gauge-score-text">{overallScore} / 100</div>
        </div>

        {/* Gauge 2: Upcoming Feature Placeholder */}
        <div className="prep-gauge-item upcoming-feature">
          <div className="prep-gauge-label">Number of Weeks</div>
          <div className="upcoming-overlay">Upcoming Feature</div>
          <RiskMeter score={0} />
        </div>

        {/* Gauge 3: Upcoming Feature Placeholder */}
        <div className="prep-gauge-item upcoming-feature">
          <div className="prep-gauge-label">Market Condition</div>
          <div className="upcoming-overlay">Upcoming Feature</div>
          <RiskMeter score={0} />
        </div>

        {/* Gauge 4: Upcoming Feature Placeholder */}
        <div className="prep-gauge-item upcoming-feature">
          <div className="prep-gauge-label">Motivation</div>
          <div className="upcoming-overlay">Upcoming Feature</div>
          <RiskMeter score={0} />
        </div>

      </div>

      {/* 🔹 Rows underneath */}
      {prepRows.p && prepRows.p.questions && prepRows.p.questions.length > 0 ? (
        <PrepRow row={prepRows.p} />
      ) : (
        <div className="prep-panel-empty">No P row questions available.</div>
      )}

      {prepRows.r && prepRows.r.questions && prepRows.r.questions.length > 0 ? (
        <PrepRow row={prepRows.r} />
      ) : null}

      {prepRows.e && prepRows.e.questions && prepRows.e.questions.length > 0 ? (
        <PrepRow row={prepRows.e} />
      ) : null}

      {prepRows.p2 && prepRows.p2.questions && prepRows.p2.questions.length > 0 ? (
        <PrepRow row={prepRows.p2} />
      ) : null}
    </div>
  );
};

export default PrepPanel;

// // frontend/src/components/PrepPanel.js

// import React from 'react';
// import PrepRow from './PrepRow';
// import RiskMeter from './RiskMeter';
// import './PrepPanel.css';

// // same scoring logic as PrepRow
// function getRowScore(row) {
//   if (!row || !row.questions || row.questions.length === 0) return 0;
//   const yesCount = row.questions.filter((q) => q.value === 'yes').length;
//   return Math.round((yesCount / row.questions.length) * 100);
// }

// const PrepPanel = ({ prepRows }) => {
//   console.log('PrepPanel - received prepRows:', prepRows);

//   if (!prepRows || !prepRows.p) {
//     return (
//       <div className="prep-panel">
//         <h3 className="prep-panel-title">PREP Assessment</h3>
//         <div className="prep-panel-empty">
//           No PREP data available for this job yet.
//         </div>
//       </div>
//     );
//   }

//   const pScore  = getRowScore(prepRows.p);
//   const rScore  = getRowScore(prepRows.r);
//   const eScore  = getRowScore(prepRows.e);
//   const p2Score = getRowScore(prepRows.p2);

//   return (
//     <div className="prep-panel">
//       <h3 className="prep-panel-title">PREP Assessment</h3>

//       {/* 🔹 Gauge strip on top */}
//       <div className="prep-gauge-strip">
//         {prepRows.p && (
//           <div className="prep-gauge-item">
//             <div className="prep-gauge-label">P – Posting &amp; Application</div>
//             <RiskMeter score={pScore} />
//           </div>
//         )}

//         {prepRows.r && (
//           <div className="prep-gauge-item">
//             <div className="prep-gauge-label">R – Recruiter</div>
//             <RiskMeter score={rScore} />
//           </div>
//         )}

//         {prepRows.e && (
//           <div className="prep-gauge-item">
//             <div className="prep-gauge-label">E – Employer</div>
//             <RiskMeter score={eScore} />
//           </div>
//         )}

//         {prepRows.p2 && (
//           <div className="prep-gauge-item">
//             <div className="prep-gauge-label">P – Hiring Process &amp; Risk</div>
//             <RiskMeter score={p2Score} />
//           </div>
//         )}
//       </div>

//       {/* 🔹 Rows underneath */}
//       {prepRows.p && prepRows.p.questions && prepRows.p.questions.length > 0 ? (
//         <PrepRow row={prepRows.p} />
//       ) : (
//         <div className="prep-panel-empty">No P row questions available.</div>
//       )}

//       {prepRows.r && prepRows.r.questions && prepRows.r.questions.length > 0 ? (
//         <PrepRow row={prepRows.r} />
//       ) : null}

//       {prepRows.e && prepRows.e.questions && prepRows.e.questions.length > 0 ? (
//         <PrepRow row={prepRows.e} />
//       ) : null}

//       {prepRows.p2 && prepRows.p2.questions && prepRows.p2.questions.length > 0 ? (
//         <PrepRow row={prepRows.p2} />
//       ) : null}
//     </div>
//   );
// };

// export default PrepPanel;
